import { Grid, Typography } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';


const ArchiveChatComponent = (props: any) => {
    
    const { actionData, stepAction } = props;
    const { onBlurOfFallBackOfBtnVar, nodes, currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload

    useEffect(() => {
        if(!stepAction?.flag_saved_in_BE){
            onBlurOfFallBackOfBtnVar(nodes, currentActiveNodeConfig, stepAction.chatbot_step_action_id, {},
                {
                    updateType: "editExistingStepAction"
                }
            )
        }
    }, [stepAction])

    return (
        <>
            <Grid item>
                <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`} mt={1}>
                    Archive Chat
                </Typography>
            </Grid>
        </>
    )
}

export default ArchiveChatComponent
